var exports = {
  "Qs": "GameActivitySettingsTab.module__content___NEFMTX",
  "h_": "GameActivitySettingsTab.module__description___NEFMTX",
  "o1": "GameActivitySettingsTab.module__actions___NEFMTX",
  "aO": "GameActivitySettingsTab.module__rules___NEFMTX",
  "Hu": "GameActivitySettingsTab.module__rule___NEFMTX",
  "hF": "GameActivitySettingsTab.module__input___NEFMTX",
};

module.exports = exports;
